// EL TEXTO DE UNA PÁGINA DE PDF, CON LAS PALABRAS ENTERAS (E-412).
//
// Paula Angarita, 2026-11-02: *"tenemos problemas al cargar la elegibilidad de
// Virginia, no lee la documentación pendiente; creamos otro archivo de
// documento pendiente más específico y tampoco lo reconoce"*.
//
// Las cartas de Virginia's Insurance Marketplace son la página web impresa a
// PDF, con letras espaciadas en los títulos. pdf.js entrega cada trozo por
// separado ("I", "n c", "o", "me"…), y unirlos todos con un espacio dejaba
// "I n c o me (Not Verified)" y "A pp lica nt Ve r ifica t i ons": el lector no
// encontraba ni "Income" ni "Applicant Verifications" y decía que no había nada.
//
// Aquí dos trozos seguidos de la MISMA línea que se tocan (sin hueco visible
// entre ellos) se pegan sin espacio, que es como se ven en la pantalla. Si hay
// hueco, o cambia la línea, va un espacio como siempre.

/**
 * @param {Array<{str: string, transform?: number[], width?: number, height?: number, hasEOL?: boolean}>} items
 * @returns {string}
 */
export function unirTextoDeLaPagina(items) {
  let out = '';
  let prev = null;
  for (const it of Array.isArray(items) ? items : []) {
    const s = String((it && it.str) || '');
    if (!s) { if (it && it.hasEOL) { out += ' '; prev = null; } continue; }
    if (prev && seTocan(prev, it)) out += s;
    else out += (out ? ' ' : '') + s;
    prev = it.hasEOL ? null : it;
    if (it.hasEOL) out += ' ';
  }
  return out;
}

function seTocan(a, b) {
  const ta = a.transform, tb = b.transform;
  if (!Array.isArray(ta) || !Array.isArray(tb) || typeof a.width !== 'number') return false;
  // Si alguno ya trae el espacio en el borde, no hay palabra partida.
  if (/\s$/.test(a.str) || /^\s/.test(b.str)) return false;
  const alto = Math.abs(ta[3]) || Math.abs(tb[3]) || a.height || 10;
  const mismaLinea = Math.abs(ta[5] - tb[5]) < alto * 0.3;
  if (!mismaLinea) return false;
  const hueco = tb[4] - (ta[4] + a.width);
  // Un espacio de verdad mide ~0.25 del alto de la letra; por debajo de 0.12
  // es la misma palabra con letras espaciadas.
  return hueco > -alto * 0.5 && hueco < alto * 0.12;
}
